'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormContainer = require('./FormContainer');

var _FormContainer2 = _interopRequireDefault(_FormContainer);

var _actions = require('../IntlProviderContainer/actions');

var _i18n = require('../../util/i18n');

var _actions2 = require('../MuiThemeProviderContainer/actions');

var _themes = require('../../style/themes');

var _themes2 = _interopRequireDefault(_themes);

var _actions3 = require('../DrawerMenuContainer/actions');

var _preferences = require('../../util/preferences');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.context.store.dispatch((0, _actions3.setAppBar)({
      title: 'SETTINGS',
      navigateBack: false
    }));

    var languages = (0, _i18n.getAvailableLanguages)(props.translations);

    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.config = {
      submitText: _i18n.submitText,
      cancelText: _i18n.cancelText,
      groups: [{
        key: 'languageSettings',
        title: _i18n.generalText,
        fields: {
          locale: {
            type: 'select',
            floatingLabelText: _i18n.languageText,
            items: languages.map(_this.getLanguageItem),
            validators: {
              required: true
            }
          },
          theme: {
            type: 'select',
            floatingLabelText: _i18n.themeText,
            items: _themes2.default.map(_this.getThemeItem),
            validators: {
              required: true
            }
          }
        }
      }],
      initialValues: {
        locale: (0, _preferences.getLanguage)(),
        theme: (0, _preferences.getTheme)()
      }
    };
    _this.FormContainer = (0, _FormContainer2.default)({
      name: 'settingsForm',
      groups: _this.config.groups
    });
    return _this;
  }

  _createClass(_class, [{
    key: 'onSubmit',
    value: function onSubmit(values) {
      var dispatch = this.context.store.dispatch;


      if (values.locale !== (0, _preferences.getLanguage)()) {
        (0, _preferences.setLanguage)(values.locale);
        dispatch((0, _actions.setLocaleAndMessages)(values.locale, this.props.translations[values.locale]));
      }

      if (values.theme !== (0, _preferences.getTheme)()) {
        (0, _preferences.setTheme)(values.theme);
        dispatch((0, _actions2.setTheme)((0, _themes.getThemeByName)(values.theme)));
        window.location = location.protocol + '//' + location.host;
      }
    }
  }, {
    key: 'getLanguageItem',
    value: function getLanguageItem(language) {
      return {
        primaryText: (0, _i18n.getLanguageText)(language),
        value: language
      };
    }
  }, {
    key: 'getThemeItem',
    value: function getThemeItem(theme) {
      return {
        primaryText: (0, _i18n.getColorText)(theme.name),
        value: theme.name
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var FormContainer = this.FormContainer;

      return _react2.default.createElement(FormContainer, _extends({
        onSubmit: this.onSubmit,
        hideCancel: true
      }, this.config));
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  translations: _react2.default.PropTypes.object.isRequired
};
_class.contextTypes = {
  store: _react2.default.PropTypes.object.isRequired
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/FormContainer/SettingsForm.js
 ** module id = 469
 ** module chunks = 0
 **/